import { QUERY_KEYS } from '@/hooks/react-query/constants'
import { __cClubService } from '@/services/client/__c.club.service'
import { useQuery } from '@tanstack/react-query'

export const useMemberActivitiesQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.MEMBER_ACTIVITIES],
    queryFn: () => __cClubService.getMemberActivities(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  })
}
